<template lang="html">

  <section class="profile">

    <div class="pageHeading">
      <h1 v-if="userOwnsProfile">Account Profile</h1>
      <h1 v-else>Account Profile ({{profileData.email}}) </h1>
    </div>

    <v-form>
      <v-container>
        <v-layout>
          <v-flex>
            <div style="text-align: left">
              <h3>Contact Info</h3>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>

          <v-flex xs12 sm4>
            <v-text-field
                    v-validate="'required'"
                    v-model="profileData.firstName"
                    label="First Name"
                    required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
                    v-validate="'required'"
                    v-model="profileData.middleName"
                    label="Middle Name"
                    required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
                    v-validate="'required'"
                    v-model="profileData.lastName"
                    label="Last Name"
                    required
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>

          <v-flex xs12 sm6>
            <v-text-field
                    v-validate="'required'"
                    :disabled="$userData.permissions[0]!='admin'"
                    v-model="profileData.email"
                    label="Email Address (used for notifications & password reset)"
                    required
            ></v-text-field>
            <small v-if="$userData.permissions[0]=='adult'">Please contact us if you need to change your email address</small>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
                    v-validate="'required'"
                    v-model="profileData.phone"
                    label="Phone Number"
                    required
            ></v-text-field>
          </v-flex>
        </v-layout>



        <v-layout v-if="$userData.permissions[0]=='admin'">
          <v-flex>
            <div style="text-align: left">
              <h3>User Details</h3>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap text-xs-center  v-if="$userData.permissions[0]=='admin'">
          <v-flex xs4>
            <v-radio-group label="Permissions:" row v-model="profileData.permissions[0]">
              <v-radio
                      key="adult"
                      label="Adult"
                      value="adult"
              ></v-radio>
              <v-radio
                      key="director"
                      label="Director"
                      value="director"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs4>
            <v-checkbox :disabled="profileData.isVerified"   v-model="profileData.isVerified"
                         hide-details label="Email Verified" ></v-checkbox>
          </v-flex>
        </v-layout>

        <v-layout  v-if="$userData.permissions[0]=='admin'">
          <v-flex>
            <div style="text-align: left">
              <h3>Documents</h3>
              <v-layout row wrap>
              <v-flex xs12 md4 v-for="document in documents" >
                <v-card elevation="1" style="margin: 5px">

                  <v-card-title primary-title>
                    <v-flex md11 xs10 text-xs-left>
                      <h3 class="mb-0">{{document.name}}</h3>

                    </v-flex>

                    <v-flex md1 xs2 text-xs-right>

                      <v-icon v-if="document.signed != false"
                              large
                              color="green"
                      >
                        check
                      </v-icon>
                      <v-icon v-else
                              large
                              color="red"
                      >
                        error
                      </v-icon>
                    </v-flex>

                  </v-card-title>


                  <v-container style="border-top: lightgray 1px solid;
    cursor: pointer;"  >

                    <v-layout row wrap >
                      <v-flex  text-xs-center>
                        <span class="topTextBottomLabels">{{document.docType}}</span>
                        <br/>
                        <strong class="bottomLabels">Type</strong>

                      </v-flex>

                      <v-flex text-xs-center v-if="document.signed != false">
                        <span class="topTextBottomLabels">{{document.signed | moment("MM-DD-YYYY")}}</span>
                        <br/>
                        <strong class="bottomLabels">Signed</strong>
                      </v-flex>

                      <v-flex text-xs-center v-if="document.signed != false">
                        <v-btn class="mx-2" target="_blank" :href="document.file" dark small color="secondary">View Record</v-btn>
                      </v-flex>

                      <v-flex text-xs-center v-else>
                        <v-btn class="mx-2" @click=""  dark small color="warning">Waive</v-btn><br/>
                        <div v-if="$userData.email =='johnbairdconsulting@gmail.com'"">
                          <v-text-field
                                  v-validate="'required'"
                                  v-model="profileData.date"
                                  label="Date"
                                  required
                          ></v-text-field>
                          <v-text-field
                                  v-validate="'required'"
                                  v-model="profileData.ip"
                                  label="ID"
                                  required
                          ></v-text-field>
                          <v-btn class="mx-2" @click="TestSignature(document._id)"  dark small color="warning">Refresh</v-btn>

                        </div>
                      </v-flex>


                    </v-layout>

                  </v-container>



                </v-card>
              </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>

      </v-container>
      <v-btn @click="updateUser" color="primary">Save Changes</v-btn>


    </v-form>
  </section>
</template>

<script lang="js">
  import moment from'moment';
  export default  {
    name: 'profile',
    props: [],
    mounted() {
        if(this.$route.params.id != undefined) {
            this.populateDifferentProfile(this.$route.params.id)
        } else {
            this.profileData = this.$userData
        }

    },
    data() {
      return {
          updateMessage: null,
          updateResult: null,
          showUpdateAlert: false,
          profileData: {},
          documents: [],
          userOwnsProfile: true
      }
    },
    methods: {
        TestSignature(theForm) {
          console.log('test sign', this.profileData, theForm)
          this.$services.users.patch(this.profileData._id,
                  {
                    "testSign": true,
                    "formID": theForm,
                    "firstName": this.profileData.firstName,
                    "lastName": this.profileData.lastName,
                    "middleName": this.profileData.middleName,
                    "email": this.profileData.email,
                    "ip": this.profileData.ip,
                    "date": this.profileData.date

                  }).then((test) => {
            console.log('result was', test)
            window.open(test.result, 'Download');


          }).catch(function (error) {
            console.error('update Error!', error);
          });
        },
        populateDifferentProfile(id) {
            this.userOwnsProfile = false
            var vueThis = this;
            this.$services.users.get(id).then((fetchedProfile) => {
                console.log('THIS IS THE PROFILE FETCH GET', fetchedProfile)


                this.profileData = fetchedProfile

            //  this.profileData.date = moment(this.profileData.createdAt).tz('America/Chicago').format('MM-DD-YYYY hh:mm A z') //'05-14-2020 01:26 PM' + ' CDT'

              var random = Math.floor(Math.random() * (345600 - 86600 + 1) + 86600);
              this.profileData.date = moment(this.profileData.createdAt).add(random, 'seconds').format('MM-DD-YYYY hh:mm A z') + ' CDT'
                this.documents = []

                this.$services.forms.get("SIlociNJovwKUyxR").then((doc) => {
                  console.log('got the result of the get', doc)


                  if (fetchedProfile.signedDocs != undefined) {
                    //let result = globalData.$data.$userData.signedDocs.find((signedDoc) => signedDoc.form == doc._id)

                    fetchedProfile.signedDocs.forEach((signedDoc) => {
                      //console.log('looking at signed doc', signedDoc )
                      if (signedDoc.form == doc._id) {
                        doc.signed = signedDoc.signed
                        doc.file = signedDoc.file
                      } else {
                        doc.signed = false
                      }

                      doc.docType = (doc.mandatory == true || doc._id == 'SIlociNJovwKUyxR') ? 'Mandatory' : 'Optional'

                      this.documents.push(doc)
                      //console.log('just puched doc', doc)
                    })
                  }
                })


                this.$structuredData.trips
                    .filter((trip) => fetchedProfile.trips.includes(trip._id)).forEach((trip) => {

                    if (trip.documents != undefined) {

                        trip.documents.forEach((document)=>{
                            var doc = {
                                name: document.name,
                                _id: document._id
                            }
                            doc.docType = document.mandatory == true ? 'Mandatory' : 'Optional'

                            if (fetchedProfile.signedDocs != undefined) {
                                let result = fetchedProfile.signedDocs.find((signedDoc) => signedDoc.form == doc._id)

                                if (result != undefined) {
                                    doc.signed = result.signed
                                    doc.file = result.file
                                } else {
                                    doc.signed = false

                                }
                            } else {
                                doc.signed = false
                            }
                            vueThis.documents.push(doc)
                        })

                    }

                })


            })
        },
        updateUser() {

            console.log('updating', this.$feathers.get('user')._id, this.$userData)
            var root = this;

            if(this.userOwnsProfile) {
                this.$services.users.patch(this.$feathers.get('user')._id,
                    {
                        "email": this.profileData.email,
                        "firstName": this.profileData.firstName,
                        "lastName": this.profileData.lastName,
                        "middleName": this.profileData.middleName,
                        "phone": this.profileData.phone,
                        "gender": this.profileData.gender

                    }).then((test) => {
                    console.log('test update', test)
                    root.$emit("alertUser", "success", "Your Profile Has Been Updated!!")


                }).catch(function (error) {
                    console.error('update Error!', error);
                    root.updateResult = "error"
                    root.$emit("alertUser", "error")
                });
            } else {
                this.$services.users.patch(this.profileData._id,
                    {
                        "firstName": this.profileData.firstName,
                        "lastName": this.profileData.lastName,
                        "middleName": this.profileData.middleName,
                        "email": this.profileData.email,
                        "phone": this.profileData.phone,
                        "gender": this.profileData.gender

                    }).then((test) => {
                    console.log('test update', test)
                    root.$emit("alertUser", "success", this.profileData.email + "'s Account Has Been Updated!!")


                }).catch(function (error) {
                    console.error('update Error!', error);
                    root.updateResult = "error"
                    root.$emit("alertUser", "error")
                });
            }
        }

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
.profile {
}
</style>
